/**
 * Organization validation schemas and constants
 *
 * This file contains shared validation rules for organization entities.
 * Used across the application to ensure consistent validation.
 */

/**
 * Organization path validation pattern
 * - Must contain only lowercase letters, numbers, hyphens, and underscores
 * - Used as URL slug and primary identifier for organizations
 *
 * @example Valid paths: "philasd", "demo-org", "test_school_2024"
 * @example Invalid paths: "Phil-ASD" (uppercase), "org@example" (special chars)
 */
export const ORGANIZATION_PATH_PATTERN = /^[a-z0-9_-]+$/;

/**
 * Case-insensitive version of the organization path pattern
 * Used when reading from URLs which may have mixed case before normalization
 */
export const ORGANIZATION_PATH_PATTERN_CASE_INSENSITIVE = /^[a-zA-Z0-9_-]+$/;

/**
 * Minimum length for organization path
 */
export const MIN_ORGANIZATION_PATH_LENGTH = 1;

/**
 * Maximum length for organization path
 * Ensures reasonable URL slugs and database storage limits
 */
export const MAX_ORGANIZATION_PATH_LENGTH = 500;

/**
 * Human-readable error message for organization path validation
 */
export const ORGANIZATION_PATH_ERROR_MESSAGE =
  "Path must only contain lowercase letters, numbers, hyphens, and underscores";
